import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './forget.css';
import { forgotPassword } from '../../api/api.js';
import Notification from '../../components/notification.js';

const RequestPasswordReset = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [notification, setNotification] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setErrors({ email: 'Email is required.' });
      return;
    }
    
    setLoading(true);
    try {
      await forgotPassword({ email });
      navigate('/reset-password', { state: { email } });
    } catch (error) {
      setNotification({ 
        type: 'error', 
        message: error.response?.data?.data?.errors?.[0]?.msg || 'Failed to send OTP'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="fp-container">
        <form className="fp-form" onSubmit={handleSubmit}>
          <h2 className="fp-title">Forgot Password</h2>
          <p className="fp-description">
            Enter your email address and we'll send you an OTP to reset your password.
          </p>

          <div className="fp-inputs">
            <div className="fp-input-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={errors.email ? 'fp-input-error' : ''}
                placeholder="Enter your email"
                required
              />
              {errors.email && <span className="fp-error-message">{errors.email}</span>}
            </div>
          </div>

          <button type="submit" className="fp-button" disabled={loading}>
            {loading ? 'Sending OTP...' : 'Send OTP'}
          </button>

          <p className="fp-back-link">
            Remembered your password? <Link to="/sign-in">Sign In</Link>
          </p>
        </form>
      </div>
      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}
    </div>
  );
};

export default RequestPasswordReset; 